import errorCodes from "@/apis/error";
import { categoryAdd } from "@/apis/product";
import { CategoryAdd, ProductCategory } from "@/types/product";
import { notification } from "antd";
import { useTranslation } from "react-i18next";


type Add = (category: CategoryAdd) => Promise<ProductCategory>
type IUseCategoryAdd = () => [{ add: Add } ]

const useCategoryAdd: IUseCategoryAdd = () => {
  const { t } = useTranslation();

  const add: Add = (props) => {
    return new Promise((resolve) => {
      categoryAdd(props)
        .then((info) => {
          resolve(info)
          notification.success({ placement: 'top', message: t('common.addSuccess') });
        })
        .catch((err) => {
          switch (err) {
            default:
              notification.error({ placement: 'top', message: t('common.addError'), description: errorCodes[err] || err });
              break;
          }
        })
    })
  }

  return [{ add }];
};

export default useCategoryAdd;